/* Mezkla product recommendations ("You may also like").

   Fetches Shopify's Product Recommendations (intent=related) through the
   Section Rendering API and injects the rendered cards. The endpoint returns
   the store's auto-generated recommendations plus any manual picks made per
   product in the Search & Discovery app.

   Two things this handles that the shared product-card infra doesn't do here:
     1. Reveal — the scroll-reveal observer in product.js only watches the main
        product section, so the injected cards never get `data-visible`. We set
        it ourselves (in a rAF so the fade-in still plays).
     2. Quick add — collection.js (which binds card size buttons) isn't loaded
        on the product page, so we bind a compact version here. The cart drawer
        IS loaded on the PDP, so cart:open / cart:updated work.

   No framework, no dependencies.
*/
(function () {
  'use strict';

  var container = document.querySelector('[data-product-recommendations]');
  if (!container) return;

  var url = container.getAttribute('data-url');
  if (!url) return;

  fetch(url, { headers: { 'X-Requested-With': 'fetch' } })
    .then(function (res) {
      if (!res.ok) throw new Error('recommendations fetch failed');
      return res.text();
    })
    .then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-product-recommendations]');
      if (!fresh) return;
      // No recommendations came back → leave the section empty (no heading).
      if (!fresh.innerHTML.trim()) return;

      container.innerHTML = fresh.innerHTML;

      // Reveal the injected cards. rAF so the opacity transition runs.
      window.requestAnimationFrame(function () {
        container.querySelectorAll('[data-reveal]').forEach(function (el) {
          el.setAttribute('data-visible', 'true');
        });
      });

      bindQuickAdd(container);
    })
    .catch(function () { /* silent — the section just stays empty */ });

  /* Compact quick-add binder — mirrors bindSizeButtons in collection.js:
     pick a size → record its variant id + enable the CTA → submit posts
     /cart/add.js and opens the cart drawer. */
  function bindQuickAdd(scope) {
    scope.querySelectorAll('[data-product-form]').forEach(function (form) {
      if (form.dataset.bound === '1') return;
      form.dataset.bound = '1';

      var hiddenInput = form.querySelector('[data-variant-input]');
      var sizeBtns = form.querySelectorAll('[data-size]');
      var cta = form.querySelector('[data-quick-add-cta]');

      sizeBtns.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (btn.disabled) return;
          if (hiddenInput) hiddenInput.value = btn.getAttribute('data-variant-id') || '';
          sizeBtns.forEach(function (b) { b.setAttribute('data-active', 'false'); });
          btn.setAttribute('data-active', 'true');
          if (cta) cta.disabled = false;
        });
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var variantId = hiddenInput ? hiddenInput.value : '';
        if (!variantId || (cta && cta.disabled)) return;
        if (cta) cta.disabled = true;

        var body = new FormData();
        body.append('id', variantId);
        body.append('quantity', '1');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: body
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add-to-cart failed');
            return r.json();
          })
          .then(function () {
            document.dispatchEvent(new CustomEvent('cart:updated'));
            document.dispatchEvent(new CustomEvent('cart:open'));
            if (cta) cta.disabled = false;
          })
          .catch(function () {
            if (cta) cta.disabled = false;
            form.submit();
          });
      });
    });
  }
})();
